import { UserSubmittableDataRecord } from './user-submittable-data-record';

export class UserSubmittableDataBatch {
  public wellId: number;
  public submitMode: string;
  public Injections: Array<UserSubmittableDataRecord> = new Array<UserSubmittableDataRecord>();
}
